import { createSelector } from 'reselect'

export const dhiTransitsStateSelector = state => state.dhiTransits
export const dhiTransitsSelector = createSelector(dhiTransitsStateSelector)
